import * as _ from "lodash"
import {IHierarchyRelationship, IHierarchyStructure, INode} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {GenericRelation} from "./GenericRelation";
import {WB_PeriodRelationshipRow} from "../PA.Core/PAdbSchemaRows";
import {esWB_Period, esWB_Period_Relationship} from "../PA.Core/PAdbSchema";
import {DateUtils} from "../PA.Core/Basic/Dates";

export class PeriodRelation
    implements IHierarchyRelationship {
    private _hierStructure: IHierarchyStructure

    private _child: INode;
    private _parent: INode;

    private _bDelete: boolean
    private _original: IHierarchyRelationship

    private _rowWB_Id: number
    private _rowSrcId: string
    private _rowStatus: string
    private _rowModifiedDt: Date

    // Create on Save
    private perRelRow: WB_PeriodRelationshipRow

    constructor(structure: IHierarchyStructure, options?: { relRow?: WB_PeriodRelationshipRow }) {
        this._hierStructure = structure
        this._bDelete = false
        this.perRelRow = options?.relRow

        if (!_.isEmpty(this.perRelRow)) {
            this._child = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Period, this.perRelRow.cif.WB_PERIOD_ID)
            this._parent = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Period, this.perRelRow.cif.WB_PERIOD_ID_PRNT)
            this._rowWB_Id = this.perRelRow.cif.WB_PERIODR_ID
            this._rowSrcId = this.perRelRow.cif.SOURCE_ROW_ID
            this._rowStatus = this.perRelRow.isActive ? 'Active' : 'Deleted'
            this._rowModifiedDt =DateUtils.convertFromSAPBWTs(this.perRelRow.cif.MODIFIED_DTTS)
        }
        this._original = new GenericRelation(structure, this)
    }

    get hierarchy(): IHierarchyStructure {
        return this._hierStructure
    }

    get child(): INode {
        return this._child
    }

    get parent(): INode {
        return this._parent
    }

    get effectiveEndDt(): Date { return undefined }

    get effectiveStartDt(): Date {  return undefined }

    get isActive(): boolean {
        return !this._bDelete
    }

    get isActiveNew(): boolean {
        return (_.isEmpty(this.perRelRow) && !this._bDelete)
    }

    get isModified(): boolean {
        if (_.isEmpty(this.perRelRow))
            return false

        if (this._bDelete && !_.isEmpty(this.perRelRow))
            return true

        let wbChildId = this.child?.wbId || 0
        let wbParentId = this.parent?.wbId || 0

        if (this.perRelRow.cif.WB_PERIOD_ID != wbChildId)
            return true

        if (this.perRelRow.cif.WB_PERIOD_ID_PRNT != wbParentId)
            return true


        return false
    }

    get original(): IHierarchyRelationship {
        return this._original
    }

    get rowWB_Id(): number {
        return this._rowWB_Id
    }

    get rowSrcId(): string {
        return this._rowSrcId
    }

    get rowStatus(): string {
        return this._rowStatus
    }

    get rowModifiedDt(): Date {
        return this._rowModifiedDt
    }


    setChild(aNode: INode): void {
        this._child = aNode
    }

    setParent(aNode: INode): void {
        this._parent = aNode
    }

    setEffectiveStartDt(aDate: Date): void { }

    setEffectiveEndDt(aDate: Date): void { }

    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        const self = this
        if (!self.isModified && !self.isActiveNew)
            return

        // create record if needed
        if (_.isEmpty(self.perRelRow)) {
            if (self._bDelete)
                return
            self.perRelRow = <WB_PeriodRelationshipRow>await self._hierStructure.dbContext.createRecordWithKey(esWB_Period_Relationship)
            self.perRelRow.setDefaults()
            self.perRelRow.cif.WB_PERIODH_ID = self._hierStructure.wbId
            self._hierStructure.dbContext.add(esWB_Period_Relationship, self.perRelRow)
        }

        // Currently assumes everything is set..
        // Set child, parent, dates
        if (self._bDelete) {
            self.perRelRow.markDeleted()
        } else {
            self.perRelRow.cif.WB_PERIOD_ID = (self.child?.wbId || 0)
            self.perRelRow.cif.WB_PERIOD_ID_PRNT = (self.parent?.wbId || 0)
        }
        await self._hierStructure.dbContext.SaveBatch(esWB_Period_Relationship, self.perRelRow)

    }


}